import CalloutFont from '@jbhi-fi/lanyard-ui/font/CalloutFont';
import CrazyFont from '@jbhi-fi/lanyard-ui/font/CrazyFont';
import React from 'react';
import { styles } from './JBBonusGiftCard.css';

const GIFT_CARD_IMAGE_SRC = 'https://cdn.shopify.com/s/files/1/0024/9803/5810/files/jb-gift-card.png';

type JBBonusGiftCardProps = {
  variant?: 'small' | 'large' | 'mobile';
};

export const JBBonusGiftCard = ({ variant }: JBBonusGiftCardProps) => {
  const isMobileVariant = variant === 'mobile';
  const isLargeVariant = variant === 'large';
  const width = isMobileVariant ? '42px' : isLargeVariant ? '80px' : '72px';
  const height = isMobileVariant ? '27px' : isLargeVariant ? '55px' : '50px';

  return (
    <div className={styles.container({ isMobileVariant, isLargeVariant })}>
      <CrazyFont className={styles.bonus({ isMobileVariant, isLargeVariant })}>BONUS</CrazyFont>
      <div className={styles.imageContainer}>
        <CalloutFont className={styles.jbGiftCard({ isMobileVariant, isLargeVariant })}>JB GIFT CARD</CalloutFont>
        <img
          src={GIFT_CARD_IMAGE_SRC}
          width={width}
          height={height}
          alt="giftcard"
          className={styles.image({ isMobileVariant, isLargeVariant })}
        />
      </div>
    </div>
  );
};
